import urljoin from 'url-join';
import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import { UninstallAppRequest } from '../../shared/models';
import { IAppApiUninstall } from '../../shared/services/appApiFactory';
import { InstallGovNotifyRequest } from '../models/request/installGovNotifyRequest';
import { GovNotifyInstalledApp } from '../models/govNotifyInstalledApp';
import { GetGovNotifyTemplatesViewModel } from '../models/response/getGovNotifyTemplatesViewModel';
import { GetGovNotifyTemplatesRequest } from '../models/request/getGovNotifyTemplatesRequest';
import { GovNotifyBearerTokenViewModel } from '../models/govNotifyBearerTokenViewModel';
import { GetGovNotifyBearerTokenRequest } from '../models/request/getGovNotifyBearerTokenRequest';
import { GovNotifyServiceViewModel } from '../models/govNotifyServiceViewModel';

class GovNotifyApiService implements IAppApiUninstall {
	private version = 'v1';

	public getDeliveryWebhookUrl() {
		return `${config().govNotifyHost}/${this.version}/webhook/delivery`;
	}

	public getMessageWebhookUrl() {
		return `${config().govNotifyHost}/${this.version}/webhook/message`;
	}

	public install(
		request: InstallGovNotifyRequest
	): Promise<void> {
		return api.send<InstallGovNotifyRequest, void>(
			'POST',
			urljoin(config().govNotifyHost, this.version, 'app', 'install'),
			request
		);
	}

	public uninstall(
		workspaceId: string,
		installId: string
	): Promise<void> {
		const request = {
			workspaceId,
			installId
		} as UninstallAppRequest;

		return api.send<UninstallAppRequest, void>(
			'POST',
			urljoin(config().govNotifyHost, this.version, 'app', 'uninstall'),
			request);
	}

	public getInstalledApp(
		workspaceId: string
	): Promise<GovNotifyInstalledApp> {
		return api.send<void, GovNotifyInstalledApp>(
			'GET',
			urljoin(config().govNotifyHost, this.version, `app?workspaceid=${workspaceId}`)
		);
	}

	public getTemplates(
		workspaceId: string,
		apiKey: string
	): Promise<GetGovNotifyTemplatesViewModel> {
		const request = {
			workspaceId,
			apiKey
		} as GetGovNotifyTemplatesRequest;
		return api.send<GetGovNotifyTemplatesRequest, GetGovNotifyTemplatesViewModel>(
			'POST',
			urljoin(config().govNotifyHost, this.version, 'templates'),
			request
		);
	}

	public getBearerToken(workspaceId: string): Promise<GovNotifyBearerTokenViewModel> {
		const request = {
			workspaceId
		} as GetGovNotifyBearerTokenRequest;
		return api.send<GetGovNotifyBearerTokenRequest, GovNotifyBearerTokenViewModel>(
			'POST',
			urljoin(config().govNotifyHost, this.version, 'token'),
			request
		);
	}

	public getServices(workspaceId: string): Promise<GovNotifyServiceViewModel[]> {
		return api.send('GET', urljoin(config().govNotifyHost, this.version, 'workspaces', workspaceId, 'services'));
	}

	public updateServices(workspaceId: string, services: GovNotifyServiceViewModel[]) {
		return api.send('PATCH', urljoin(config().govNotifyHost, this.version, 'workspaces', workspaceId, 'services'), services);
	}

	public canUninstall(): boolean {
		return true;
	}

	public getUninstallNotAllowedMessage(): string {
		return '';
	}
}

export const govNotifyApi = new GovNotifyApiService();
